import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, className = "", y = 32, dataTestId }) => (
  <motion.div
    className={className}
    data-testid={dataTestId}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.7, delay, ease: [0.22, 1, 0.36, 1] }}
  >
    {children}
  </motion.div>
);

export const SectionLabel = ({ children }) => (
  <span className="font-mono text-xs uppercase tracking-[0.25em] text-azure">
    {children}
  </span>
);
